export const siteSettingsPreviewQueryProjection = `
  {
    "allSanitySiteSettings": {
      "nodes": *[_type == "siteSettings"]
    }
  }
`
